import PDFViewer from './components/PDFViewer.vue'

const vpdf = {}
vpdf.install = (Vue) => {

    /**
     * Sets custom component name (if provided)
     */
    Vue.component('PDFViewer', PDFViewer)
}

export default vpdf


